module.exports = __webpack_public_path__ + "static/media/Microprocessor.919e5bc3.jpg";